<div>
  <nm-error [errorMessage]="errorMessage" *ngIf="showErrorFlag" (errorWindowHide)="hideError()"></nm-error>
  <router-outlet></router-outlet>
</div>
